import { FileBase } from '../FileBase';

export class Blocklist extends FileBase {
  useStandard = true;
  isValid() {
    return this.useStandard || super.isValid();
  }

  isEqualTo(other) {
    return (
      (!this.isValid() && !other.isValid()) ||
      (this.useStandard === other.useStandard && super.isEqualTo(other))
    );
  }
}
